import { useEffect, useState } from "react";
import { useAnnouncements } from "./AnnoucementsContext";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  Grid,
  IconButton,
  Input,
  Table,
  TableCell,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import {
  deleteAdminWebFiles,
  getAdminWebFiles,
  uploadAdminWebFiles,
  downloadAdminWebFiles,
} from "./utils";
import DeleteIcon from "@mui/icons-material/Delete";

const AnnouncementWebFilesAdmin = () => {
  const [open, setOpen] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const {
    adminWebFiles,
    setAdminWebFiles,
    openAdminWebFilesPage,
    setOpenAdminWebFilesPage,
  } = useAnnouncements();

  useEffect(() => {
    setOpen(openAdminWebFilesPage);
  }, [openAdminWebFilesPage, setOpenAdminWebFilesPage, adminWebFiles]);

  const onClose = (e, reason) => {
    setOpenAdminWebFilesPage(false);
    setOpen(false);
  };

  const handleFileChange = (event) => {
    setUploadedFile(event.target.files[0]);
  };

  const handleWebFileUpload = (event) => {
    if (!uploadedFile) {
      alert("Please select a file");
      return;
    }
    uploadAdminWebFiles(uploadedFile).then(() => {
      setUploadedFile(null);
      setOpen(false);
      getAdminWebFiles(setAdminWebFiles);
    });
  };

  const deleteWebAdminFile = (webfilePath) => {
    deleteAdminWebFiles(webfilePath).then(() => {
      setOpen(false);
      setUploadedFile(null);
      getAdminWebFiles(setAdminWebFiles);
    });
  };

  const downloadWebAdminFile = (filename, webfilePath) => {
    downloadAdminWebFiles(filename, webfilePath).then(() => {});
  };

  return (
    adminWebFiles && (
      <Dialog maxWidth="true" open={open} onClose={onClose}>
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            right: 20,
            top: 8,
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <Card sx={{ borderRadius: 3, overflow: "auto" }}>
          <CardHeader
            title={<font className="layer-title"> Admin Web Files </font>}
            align="center"
            className={"styledtablerow"}
          />
          <CardContent
            sx={{
              paddingTop: 1,
              paddingLeft: 0,
              paddingRight: 0,
            }}
          >
            <Box
              component="form"
              size="small"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "35ch" },
                align: "center",
              }}
            >
              <Grid
                container
                spacing={{ xs: 1 }}
                sx={{ justifyContent: "center" }}
              >
                <Grid>
                  <Table>
                    <TableRow className="report-header">
                      <TableCell> File Name </TableCell>
                      <TableCell> Modification Date </TableCell>
                      <TableCell> Alt Text</TableCell>
                      <TableCell> Action </TableCell>
                    </TableRow>
                    {adminWebFiles.map((eachChild) => {
                      return (
                        <TableRow key={eachChild.path}>
                          <TableCell>
                            <Link
                              style={{ textDecoration: "none" }}
                              className="hyper-links"
                              onClick={(e) => {
                                downloadWebAdminFile(
                                  eachChild.name,
                                  eachChild.path,
                                );
                              }}
                            >
                              {eachChild.name}
                            </Link>
                          </TableCell>
                          <TableCell> {eachChild.modificationDate} </TableCell>
                          <TableCell> {eachChild.altText} </TableCell>
                          <TableCell>
                            <Link
                              style={{ textDecoration: "none" }}
                              className="hyper-links"
                              onClick={(e) => {
                                deleteWebAdminFile(eachChild.path);
                              }}
                            >
                              <DeleteIcon />
                            </Link>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </Table>
                  <Table>
                    <TableRow>
                      <TableCell align="center">
                        <Input type="file" onChange={handleFileChange} />
                        <Button onClick={handleWebFileUpload}>Upload</Button>
                      </TableCell>
                    </TableRow>
                  </Table>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Dialog>
    )
  );
};
export default AnnouncementWebFilesAdmin;
